import React from 'react'
import _ from 'lodash'
import { AgGridReact, AgGridColumn } from 'ag-grid-react'
import 'ag-grid-enterprise'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'

import Styled from './styled'

export default function PivotTable({ rowData = [], columns = [] }) {
  // const [gridApi, setGridApi] = useState(null)
  // const [gridColumnApi, setGridColumnApi] = useState(null)

  // const onGridReady = (params) => {
  //   setGridApi(params.api)
  //   setGridColumnApi(params.columnApi)
  // }

  return (
    <Styled className="pivot-table-component">
      <div className="wrapper">
        <div className="ag-theme-alpine">
          <AgGridReact
            defaultColDef={{
              flex: 1,
              minWidth: 150,
              sortable: true,
              resizable: true,
            }}
            autoGroupColumnDef={{ minWidth: 250 }}
            pivotMode={true}
            sideBar={'columns'}
            // onGridReady={onGridReady}
            rowData={rowData}
          >
            {_.map(columns, (column, index) => {
              return <AgGridColumn key={index} {...column} />
            })}
          </AgGridReact>
        </div>
      </div>
    </Styled>
  )
}
